"use strict";

function manukaFeatures() {
  var featuresSlider = document.querySelectorAll('.c-manuka-features__images--slider');
  if (featuresSlider) {
    featuresSlider.forEach(function (featureSlider) {
      new Swiper(featureSlider, {
        spaceBetween: 80,
        sliderPerView: 'auto',
        autoplay: true,
        // Navigation arrows
        navigation: {
          nextEl: '.c-manuka-features__images--slider__nav--next',
          prevEl: '.c-manuka-features__images--slider__nav--prev'
        }
      });
    });
  }
}
manukaFeatures();